


























































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    props: {
        defaultState: {
            type: Number,
            required: false,
            default: 0
        },
        isCentered: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputLabelVisible: {
            type: Boolean,
            required: false,
            default: true
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: "",
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        valueALabel: {
            type: String,
            required: true
        },
        valueBLabel: {
            type: String,
            required: true
        },
        valueA: {
            type: String,
            required: true,
        },
        valueB: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function() {
        return {
            uniqueId: uuidv4() as string,
            isFocused: false as boolean,
            currentState: this.defaultState as number, // 0 (State A), 1 (State B)
        };
    },
    computed: {
        internalValue: function(): string {
            if (this.currentState === 0) {
                return this.valueA;
            } else {
                return this.valueB;
            }
        },
        currentInputId: function(): string {
            if (this.currentState === 0) {
                return `input-toggle-a-${this.uniqueId}`;
            } else {
                return `input-toggle-b-${this.uniqueId}`;
            }
        },
        currentValueLabel: function(): string {
            if (this.currentState === 1) {
                return this.valueBLabel;
            }

            return this.valueALabel;
        },
        inactiveValueLabel: function(): string {
            if (this.currentState === 0) {
                return this.valueBLabel;
            }

            return this.valueALabel;
        }
    },
    watch: {
        internalValue: function() {
            this.$emit("change", this.internalValue);
        },
    },
    methods: {
        handleFocus: function() {
            if (!this.disabled) {
                this.isFocused = true;
            }
        },
        handleBlur: function() {
            this.isFocused = false;
        },
        handleClick: function() {
            this.$emit("click-event");
        },
        actionClick: function() {
            if (!this.disabled && !this.readonly) {
                if (this.currentState === 0) {
                    this.currentState = 1;
                } else {
                    this.currentState = 0;
                }

                const currentInput = document.getElementById(this.currentInputId);

                if (currentInput) {
                    currentInput.focus();
                }
            }
        }
    }
});
